// extracted by mini-css-extract-plugin
export default {"dialog":"ModalWindow_dialog__pa+Jc","dialog_paper":"ModalWindow_dialog_paper__lhCIg","title":"ModalWindow_title__jNDcO","content":"ModalWindow_content__JaEOB"};